"use client";

import { SOfferDto, SProduct } from "@/__generated__/graphql";
import SnappPayHorizontalIcon from "@/app/_components/Icons/SnappPayHorizontalIcon";
import { Add, Circle, MoreVert } from "@mui/icons-material";
import { Box, Card, CardContent, Icon, IconButton, Skeleton, Typography, useTheme } from "@mui/material";
import Image from "next/image";
import { memo } from "react";
import { RevealEffect } from "react-reveal-effect";


function ProductCardSnappPayIconSkeleton() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        zIndex: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Skeleton variant="rectangular" width={"100%"} sx={{
        height: {
          xs: 21.22
        }
      }} animation={"wave"} style={{}} >

      </Skeleton>
    </Box>
  );
}

export default memo(ProductCardSnappPayIconSkeleton);
